import styled from "styled-components"
import searchIcon from "../../svg/search-icon.svg"


export const CourseForm = styled.form`
    flex-grow: 1;
    position: relative;
`

export const CourseFormInput = styled.input`
    ${({ theme: { typography } }) => typography.desktop.body};
    font-weight: ${({ theme: { fontWeight } }) => fontWeight.semiBold};
    font-size: 16px;
    width: 100%;
    height: 47px;
    border-radius: 25px;
    border: 1px solid #949494;
    background-color: #fff;
    padding: 0 20px 0 45px;
    position: relative;

  
  :active, :focus {
    border: 2px solid #4c0ffb;
   
  }
    
`

export const SearchIcon = styled(searchIcon)`
    position: absolute;
    z-index: 200;
    left: 20px;
    top: 18px;
   
`

export const ClearButton = styled.button`
    position: absolute;
    top: 3px;
    right: 13px;
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    outline: none;
    color: black;
    padding: 10px;
:hover,
     &.active {
 
   color: #4c0ffb;
   
  }
`;